import { render, staticRenderFns } from "./AdminLeftNavigation.vue?vue&type=template&id=10c06275&scoped=true"
import script from "./AdminLeftNavigation.vue?vue&type=script&lang=js"
export * from "./AdminLeftNavigation.vue?vue&type=script&lang=js"
import style0 from "./AdminLeftNavigation.vue?vue&type=style&index=0&id=10c06275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c06275",
  null
  
)

export default component.exports